/* eslint-disable arrow-body-style */
import React from 'react';
import { SearchResults } from '@src/common/FilterPanelPage/results/SearchResults';
import { useEventSearchResultsStore } from '../mothership/eventSearchResults.state';
import { Results } from './resultsComponents/Results';
import { eventSearchId } from '../types';

export const EventSearchResults = () => {
  const status = useEventSearchResultsStore((state) => state.resultsStatus);

  return (
    <SearchResults
      id={eventSearchId}
      status={status}
      iconPending="data_exploration"
      SuccessComp={<Results id={eventSearchId} />}
    />
  );
};
